import React from "react";
import Image from "next/image";
import { NEXT_IMAGE_CDN } from "@/src/lib/util/config";
import { callHref } from "@/src/lib/util/callUtils";

const InfoWindowContent = ({ center, isMobile = false }) => {
    const centerTypeText =
        center.centreType === "LAB"
            ? "Diagnostic Centre"
            : "Sample Collection Centre";

    const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${
        center.googlePlaceId
            ? `HOD&destination_place_id=${center.googlePlaceId}`
            : `${center.latitude},${center.longitude}`
    }`;

    const whatsappUrl = center?.whatsapp?.startsWith("http")
        ? center.whatsapp
        : `https://${center?.whatsapp}`;

    return (
        <div className="bg-white w-full box-border overflow-hidden">
            {/* Header Section */}
            <div className="flex justify-between gap-3">
                {/* Text Information */}
                <div className="grow">
                    <div className="font-semibold text-xl mb-2">
                        {center?.name}
                    </div>
                    <div className="text-sm font-medium">{centerTypeText}</div>
                    <div className="text-sm font-semibold">{center.phone}</div>
                </div>

                {!isMobile && (
                    <div className="pl-3 flex items-center justify-center">
                        <Image
                            src={`${NEXT_IMAGE_CDN}/icon/hod_logo.svg`}
                            alt="House Of Diagnostics"
                            width={100}
                            height={100}
                        />
                    </div>
                )}
            </div>

            {/* Action Icons Section */}
            <div className="mt-3 bg-gray-200 rounded-lg flex justify-center items-center py-2 w-full">
                {/* WhatsApp Icon */}
                <div
                    className="cursor-pointer mx-2.5"
                    id="whatsapp-icon"
                    data-whatsapp-url={whatsappUrl}
                    title="Chat on WhatsApp"
                >
                    <Image
                        src="/images/whatsapp.svg"
                        alt="WhatsApp"
                        width={30}
                        height={30}
                        className="w-8 h-8"
                    />
                </div>

                {/* Map Directions Icon */}
                <a
                    href={googleMapsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mx-2.5"
                    title="Get Directions"
                >
                    <Image
                        src="/images/direction.svg"
                        alt="Get Directions"
                        width={30}
                        height={30}
                        className="w-8 h-8"
                    />
                </a>

                {/* Phone Call Icon */}
                <a
                    href={callHref(center.phone)}
                    className="mx-2.5"
                    title="Call"
                >
                    <Image
                        src="/images/call.svg"
                        alt="Call"
                        width={30}
                        height={30}
                        className="w-8 h-8"
                    />
                </a>
            </div>
        </div>
    );
};

export default InfoWindowContent;
